import styled, {keyframes} from "styled-components";

export const StyledHeading = styled.h3`
  font-size: 3rem;
  @media (max-width: 48rem) {
    font-size: 1.6rem;
  }
`;

export const StyledSubHeading = styled.h3`
  font-size: 2rem;
  @media (max-width: 48rem) {
    font-size: 1.2rem;
  }
`;

export const blink = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  text-align: left;
  width: 100%;
  padding: 0 0.5rem;
  flex-shrink: 0;
  margin-bottom: 1rem;
`;

export const AnimatedText = styled.span`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
`;

export const Cursor = styled.span`
  display: inline-block;
  font-weight: bold;
  animation: ${blink} 0.7s step-end infinite;
`;
